<div class="not-found">
  <div class="not-found__content">
    <img
      class="not-found__mascot"
      src="/images/logo/404.png"
      alt="Perrón perdido"
      width="160"
      height="160"
    />
    <h1 class="not-found__heading">{{ heading() }}</h1>
    <p class="not-found__body">{{ body() }}</p>
    <app-button variant="primary" size="lg" (click)="goToCatalog.emit()">
      Explorar el catálogo
    </app-button>
  </div>
</div>
